export default Object.freeze({
  LOAD_TERMS_SUCCESS: 'LOAD_TERMS_SUCCESS',
  LOAD_TERMS_FAIL: 'LOAD_TERMS_FAIL',
  ACCEPT_TERMS_SUCCESS: 'ACCEPT_TERMS_SUCCESS',
  ACCEPT_TERMS_FAIL: 'ACCEPT_TERMS_FAIL',
  CREATE_USER_SUCCESS: 'CREATE_USER_SUCCESS',
  CREATE_USER_FAIL: 'CREATE_USER_FAIL',
});
